import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-breadcromb',
  templateUrl: './breadcromb.component.html',
  styleUrls: ['./breadcromb.component.css']
})
export class BreadcrombComponent implements OnInit {
  @Input() pageName: string;

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  goToHome() {
    this.router.navigate(['/']).then(r => window.location.reload());
  }
}
